import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import DashIcon from 'components/icons/DashIcon';
import { useAuthUser } from 'react-auth-kit';
import { CHECK_PERMISSIONS } from 'Constaints';
import useDataFetching from 'hooks/useDataFetching';
import { config } from 'variables/config';
import { CHECK_ROLES_PERMISSIONS } from 'Constaints';
import { ListItemIcon, ListItemText, MenuItem, MenuList, Paper, Skeleton } from '@mui/material';
import { COLORS } from 'constant/COLORS';
import { useSidebar } from 'hooks/UseSideBar';
import { useTranslation } from 'react-i18next';
// chakra imports

export function SidebarLinks(props) {
  // Chakra color mode
  let location = useLocation();
  const navigate = useNavigate();
  const { routes } = props;

  const { t } = useTranslation('sidebar');

  const auth = useAuthUser();

  const [loadingU, errorU, user, fetchDataU] = useDataFetching(
    `${config.app.api_url}/users/${auth()?.user?.id}`
  );

  const { isCollapsed, toggleSidebar } = useSidebar();
  const SideBarCard = ({ route, index, vertical }) => {
    return (
      CHECK_ROLES_PERMISSIONS(user?.data?.roles, route?.permissionName) &&
      route.displayOnSideBar && (
        <MenuItem
          key={index}
          selected={activeRoute(route.path) === true}
          onClick={() => {
            navigate(route.layout + '/' + route.path);
          }}
          className="side-bar-transition"
          sx={{ flexDirection: vertical ? 'column' : 'row', paddingBlock: vertical ? 3 : 1 }}
        >
          <ListItemIcon color="red" sx={activeRoute(route.path) === true ? { color: 'white' } : {}}>
            {route.icon ? route.icon : <DashIcon />}{' '}
          </ListItemIcon>{' '}
          {
            <ListItemText
              className={` flex side-bar-transition ${isCollapsed ? 'hidden' : 'visible'} ${
                activeRoute(route.path) === true ? ' font-bold text-white dark:text-white' : ''
              }`}
            >
              {t(route.name)}
            </ListItemText>
          }
        </MenuItem>
      )
    );
  };
  // console.log("user", auth()?.user?.id);

  // verifies if routeName is the one active (in browser input)
  const activeRoute = (routeName) => {
    return location.pathname.includes(routeName);
  };

  const createLinks = (routes) => {
    const authRoutes = routes.filter((route, index) => {
      if (
        (route.layout === '/admin' || route.layout === '/auth' || route.layout === '/rtl') &&
        route.name != 'Employees' &&
        route.name != 'Regions' &&
        route.name != 'Agent Enterprises' &&
        route.name != 'Agent Employees' &&
        route.name != 'EntreprisesUs'
      ) {
        const display =
          route?.displayOnSideBar &&
          user?.data?.roles?.filter((role) => route?.roles?.includes(role?.name)).length > 0;
        if (!display) return false;
        return true;
      }
    });
    return authRoutes.map((route, index) => {
      return (
        <SideBarCard
          key={index}
          route={route}
          index={index}
          vertical={authRoutes.length < 4 ? true : false}
        />
      );
    });
  };

  // BRAND
  return loadingU ? (
    <div className={`flex flex-col gap-2 `}>
      <div className="relative mb-2 flex hover:cursor-pointer flex flex-col">
        {Array(routes?.length)
          .fill(0)
          ?.map((k) => {
            return (
              <li key={k} className={` sidebar-link  my-[3px]  cursor-pointer`}>
                <Skeleton variant="rectangular" height={50} width={'100%'} />
              </li>
            );
          })}
      </div>
    </div>
  ) : (
    <MenuList
      className="flex flex-col gap-1 side-bar"
      onMouseEnter={() => toggleSidebar('open')}
      onMouseLeave={() => toggleSidebar('close')}
    >
      {createLinks(routes)}
    </MenuList>
  );
}

export default SidebarLinks;
